module.exports = __webpack_public_path__ + "static/media/ios-app.63e469e7.png";